import {Home} from './components/home/home.jsx';

export const ROUTERS = 
  {
    component: Home
  };
